import { render, staticRenderFns } from "./AimIcon.vue?vue&type=template&id=797dd95b&"
import script from "./AimIcon.vue?vue&type=script&lang=js&"
export * from "./AimIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports